import { Box, Button, Card, Flex, Heading, Select, TextField } from '@radix-ui/themes';
import { observer } from 'mobx-react-lite';
import { toast } from 'sonner';

import { useTransactions } from '../transactions.provider';

const ALL_ADMINS_VALUE = 'ALL';

const TransactionFiltersView = () => {
   const transactionsStore = useTransactions();

   return (
      <Card m="3" className="transactions-filters">
         <Flex direction="column" gap="2" width="100%">
            <Heading as="h4" weight="medium" color="gray">
               Filters
            </Heading>

            <Flex gap="3" align="end" justify="between" wrap="wrap">
               <Flex gap="3" align="end" wrap="wrap" flexGrow="1">
                  <Box minWidth="300px" width="100%" maxWidth="560px">
                     <TextField.Root
                        placeholder="Search by company, employer ID, full name, plan, or request date"
                        size="3"
                        color="blue"
                        autoComplete="off"
                        value={transactionsStore.searchStr}
                        onChange={(e) => {
                           transactionsStore.onSearchChange(e.target.value);
                        }}
                        onKeyDown={(e) => {
                           if (e.key === 'Enter') {
                              void transactionsStore.submitSearch();
                           }
                        }}
                     />
                  </Box>

                  <Box minWidth="280px" width="280px">
                     <Select.Root
                        size="3"
                        value={transactionsStore.selectedAdminId}
                        onValueChange={(value) => {
                           transactionsStore.onAdminChange(value);
                        }}
                     >
                        <Select.Trigger color="blue" placeholder="Select Admin" style={{ width: '100%' }} />
                        <Select.Content color="blue" position="popper">
                           <Select.Item value={ALL_ADMINS_VALUE}>All managers</Select.Item>
                           {transactionsStore.admins.map((admin) => (
                              <Select.Item key={admin.id} value={String(admin.id)}>
                                 {transactionsStore.getAdminDisplayName(admin)}
                              </Select.Item>
                           ))}
                        </Select.Content>
                     </Select.Root>
                  </Box>

                  <Button
                     size="3"
                     loading={transactionsStore.loading}
                     onClick={() => {
                        void transactionsStore.submitSearch();
                     }}
                  >
                     Search
                  </Button>
               </Flex>

               <Button
                  size="3"
                  variant="surface"
                  color="blue"
                  disabled={transactionsStore.downloadTransactionsState.status === 'pending'}
                  onClick={() => {
                     transactionsStore.downloadTransactions({
                        onSuccess: () => {
                           toast.success('Transaction list downloaded');
                        },
                        onError: (message) => {
                           toast.error(message);
                        },
                     });
                  }}
               >
                  Download List
               </Button>
            </Flex>
         </Flex>
      </Card>
   );
};

export const TransactionFilters = observer(TransactionFiltersView);
